import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TrapezoidDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix } = __props;

const dimensions = computed(() => store.getters.getMeasurements( 'right-angled-triangle-mirrored', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const widthTop = computed({
	get: () => dimensions.value.width_top,
	set: (value: string) => {
		const numericValue = value;
		const widthBottom = dimensions.value.width_bottom;

		store.dispatch(action, {
			dimension: "width_top",
			value: value,
		});
		store.dispatch(action, {
			dimension: "offset_left",
			value: ( ( parseFloat(widthBottom) - parseFloat(numericValue) ) / 2 ).toFixed( 1 ),
		});
	},
});

const widthBottom = computed({
	get: () => dimensions.value.width_bottom,
	set: (value: string) => {
		const numericValue = value;
		const widthTop = dimensions.value.width_top;

		store.dispatch(action, {
			dimension: "width_bottom",
			value: value,
		});
		store.dispatch(action, {
			dimension: "offset_left",
			value: ( ( parseFloat(numericValue) - parseFloat(widthTop) ) / 2 ).toFixed( 1 ),
		});
	},
});

const height = computed({
	get: () => dimensions.value.height,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height",
			value: value,
		});
	},
});

const offsetLeft = computed({
	get: () => dimensions.value.offset_left,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "offset_left",
			value: value,
		});
	},
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "trapezoid-width_top",
        id: `${_ctx.prefix}measurements-trapezoid-width_top`,
        name: `${_ctx.prefix}measurements[dimensions][width_top]`,
        unit: "cm",
        label: dimensionLabel.value('width_top', 'trapezoid'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('width_top'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}trapezoid-width_top`),
        onBlur: () => _unref(addSizeToDataLayer)('width_top', +widthTop.value, 'trapezoid'),
        modelValue: widthTop.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((widthTop).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "trapezoid-width_bottom",
        id: `${_ctx.prefix}measurements-trapezoid-width_bottom`,
        name: `${_ctx.prefix}measurements[dimensions][width_bottom]`,
        unit: "cm",
        label: dimensionLabel.value('width_bottom', 'trapezoid'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('width_bottom'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}trapezoid-width_bottom`),
        onBlur: () => _unref(addSizeToDataLayer)('width_bottom', +widthBottom.value, 'trapezoid'),
        modelValue: widthBottom.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((widthBottom).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "trapezoid-height",
        id: `${_ctx.prefix}measurements-trapezoid-height`,
        name: `${_ctx.prefix}measurements[dimensions][height]`,
        unit: "cm",
        label: dimensionLabel.value('height', 'trapezoid'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('height'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}trapezoid-height`),
        onBlur: () => _unref(addSizeToDataLayer)('height', +height.value, 'trapezoid'),
        modelValue: height.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((height).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "trapezoid-offset_left",
        id: `${_ctx.prefix}measurements-trapezoid-offset_left`,
        name: `${_ctx.prefix}measurements[dimensions][offset_left]`,
        unit: "cm",
        hidden: "",
        label: dimensionLabel.value('offset_left', 'trapezoid'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('offset_left'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}trapezoid-offset_left`),
        onBlur: () => _unref(addSizeToDataLayer)('offset_left', +offsetLeft.value, 'trapezoid'),
        modelValue: offsetLeft.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((offsetLeft).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"])
    ]),
    _: 1
  }))
}
}

})